import React, { useEffect, useState } from 'react'
import PageHeading from '../../components/PageHeading';
import { Link, useParams } from 'react-router-dom';
import GetPlotSequenceByPlotSpecificationByProjectId from '../../APIs/ProjectPlotDetails/GetPlotSequenceByPlotSpecificationByProjectId';

export default function ProjectAllPlot({ projectId, isComponent }) {
    const [plotDataList, setPlotDataList] = useState([]);
    let id = useParams()
    let getData = async (projectId) => {
        let data = await GetPlotSequenceByPlotSpecificationByProjectId(projectId);
        if (data.status === 1) {
            if (projectId) {
                if (isComponent === undefined) {
                    setPlotDataList(data.responseValue);
                }
                else {
                    let plotsList = data.responseValue
                        .splice(0, 10)
                        .sort((a, b) => a.plotSequenceNumber - b.plotSequenceNumber);

                    setPlotDataList(plotsList);
                }

            }
            // else {
            //     setPlotDataList(data.responseValue)
            // }
        }
        else {
            setPlotDataList([])
        }
    }

    useEffect(() => {
        if (projectId) {
            getData(projectId);
        }
        else {
            getData(id.projectId);
        }
    }, [])

    return (
        <div className='landformconatiner p-3'>
            <div className='d-flex flex-row justify-content-between mb-3 ' style={{ background: "white" }}>
                <PageHeading pagename={"Plot Specification"} />
                <div className='d-flex flex-row gap-3'>
                    <div className='d-flex flex-row gap-2 justify-content-center align-items-center'>
                        <div className='color-block' style={{ backgroundColor: "#FEFA99", border: "none" }}></div>
                        <span>Booked</span>
                    </div>
                    <div className='d-flex flex-row gap-2 justify-content-center align-items-center'>
                        <div className='color-block' style={{ backgroundColor: "#8DC86C", border: "none" }}></div>
                        <span>Sold</span>
                    </div>
                    <div className='d-flex flex-row gap-2 justify-content-center align-items-center'>
                        <div className='color-block' style={{ backgroundColor: "#FE996C", border: "none" }}></div>
                        <span>Hold</span>
                    </div>
                    <div className='d-flex flex-row gap-2 justify-content-center align-items-center'>
                        <div className='color-block' style={{ backgroundColor: "rgb(53, 109, 214)", border: "none" }}></div>
                        <span>Available</span>
                    </div>
                </div>
            </div>
            <div className="custom-grid">
                {plotDataList.map((plot, index) => (
                    <Link
                        to={`/plotdefine/${plot?.productionCost + "/" + plot?.totalArea}`}
                        className="no-link-style"
                        style={{
                            background: plot?.PlotStatusColor || "#356dd6"
                        }}
                    >
                        <div
                            className="grid-block"
                            key={index}
                            style={{
                                textAlign: 'center',
                                gap:'6px',
                                color: plot?.PlotStatusColor === "#F5F6F7" ? "#000" : "#000"
                            }}
                        >
                            <strong className='projectid'>{plot?.plotNumber || plot?.PlotNumber}</strong>

                            <div className='pt-3 text-center projectarea'>
                                {plot?.dimensions || plot?.Dimensions}
                            </div>
                        </div>
                    </Link>
                    // <Link to={`/plotdefine/${plot?.productionCost + "/" + plot?.totalArea}`} className="no-link-style" style={{ background: plot.plotStatus === 1 ? "#FEFA99" : plot.plotStatus === 2 ? "#8DC86C" : plot.plotStatus === 3 ? "#FE996C" : "#356dd6" }}>
                    //     <div className="grid-block" key={index} style={{textAlign:'center', color: plot.plotStatus === 1 ? "#000" : plot.plotStatus === 2 ? "#FFF" : plot.plotStatus === 3 ? "#FFF" : "#000" }}>
                    //         <strong className='projectid'>{plot.PlotNumber}</strong>
                    //         <div className='pt-3 text-center projectarea'>{plot.Dimensions}</div>
                    //         <div className='text-center projectarea'>{plot.area} SQF</div>
                    //     </div>
                    // </Link>
                ))}
            </div>
        </div>



    )
}
